import { useGuidedModeStore } from '@/features/guided-mode/stores/guidedMode'
import { clearActiveTextModeContext } from '@/features/text-mode/analytics/text-mode-context'
import { useOverallAssessmentStore } from '@/features/overall-assessment/stores/overallAssessment'
import { useAlertStore } from '@/features/text-mode/stores/alert.store'
import { useDraftStore } from '@/features/text-mode/stores/draft.store'
import { useEvidenceStore } from '@/features/text-mode/stores/evidence.store'
import { useNoteStore } from '@/features/text-mode/stores/note.store'
import { usePatientStore } from '@/features/text-mode/stores/patient.store'
import { useQuestionStore } from '@/features/text-mode/stores/question.store'
import { useCollectStore } from '@/stores/collect'
import { useEncounterStore } from '@/stores/encounter'
import { useMrxStore } from '@/stores/mrx'
import { useTrackStore } from '@/stores/track'

export function resetAssessmentState(): void {
    useGuidedModeStore().clearObservations()
    useGuidedModeStore().resetProgress()
    useOverallAssessmentStore().reset()
    useNoteStore().reset()
    useQuestionStore().reset()
    useEvidenceStore().reset()
    useDraftStore().fullReset()
    usePatientStore().reset()
    useAlertStore().reset()
}

export async function resetEncounter(): Promise<void> {
    resetAssessmentState()
    clearActiveTextModeContext()
    useEncounterStore().reset()
    useCollectStore().clearUploaded()
    useMrxStore().reset()
    useTrackStore().reset()
}
